import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "breadcrumb float-sm-right" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = { class: "breadcrumb-item active" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "container-fluid" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "card card-primary card-outline" }
const _hoisted_14 = { class: "card-body box-profile" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<h3 class=\"profile-username text-center\"> Nina Mcintire </h3><p class=\"text-muted text-center\">Software Engineer</p><ul class=\"list-group list-group-unbordered mb-3\"><li class=\"list-group-item\"><b>Followers</b><a class=\"float-right\">1,322</a></li><li class=\"list-group-item\"><b>Following</b> <a class=\"float-right\">543</a></li><li class=\"list-group-item\"><b>Friends</b> <a class=\"float-right\">13,287</a></li></ul><button class=\"btn btn-primary btn-block\"><b>Follow</b></button>", 4)
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"card card-primary\"><div class=\"card-header\"><h3 class=\"card-title\">About Me</h3></div><div class=\"card-body\"><strong><i class=\"fas fa-book mr-1\"></i> Education</strong><p class=\"text-muted\"> B.S. in Computer Science from the University of Tennessee at Knoxville </p><hr><strong><i class=\"fas fa-map-marker-alt mr-1\"></i> Location</strong><p class=\"text-muted\">Malibu, California</p><hr><strong><i class=\"fas fa-pencil-alt mr-1\"></i> Skills</strong><p class=\"text-muted\"><span class=\"tag tag-danger\">UI Design</span><span class=\"tag tag-success\">Coding</span><span class=\"tag tag-info\">Javascript</span><span class=\"tag tag-warning\">PHP</span><span class=\"tag tag-primary\">Node.js</span></p><hr><strong><i class=\"far fa-file-alt mr-1\"></i> Notes</strong><p class=\"text-muted\"> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam fermentum enim neque. </p></div></div>", 1)
const _hoisted_21 = { class: "col-md-9" }
const _hoisted_22 = { class: "card" }
const _hoisted_23 = { class: "card-header p-2" }
const _hoisted_24 = { class: "nav nav-pills" }
const _hoisted_25 = { class: "nav-item" }
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = { class: "nav-item" }
const _hoisted_28 = { class: "card-body" }
const _hoisted_29 = { class: "tab-content" }
const _hoisted_30 = { class: "post" }
const _hoisted_31 = { class: "user-block" }
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<span class=\"username\"><a href=\"#\">Jonathan Burke Jr.</a><a href=\"#\" class=\"float-right btn-tool\"><i class=\"fas fa-times\"></i></a></span><span class=\"description\">Shared publicly - 7:30 PM today</span>", 2)
const _hoisted_34 = /*#__PURE__*/_createStaticVNode("<p> Lorem ipsum represents a long-held tradition for designers, typographers and the like. Some people hate it and argue for its demise, but others ignore the hate as they create awesome tools to help create filler text for everyone from bacon lovers to Charlie Sheen fans. </p><p><a href=\"#\" class=\"link-black text-sm mr-2\"><i class=\"fas fa-share mr-1\"></i> Share</a><a href=\"#\" class=\"link-black text-sm\"><i class=\"far fa-thumbs-up mr-1\"></i> Like</a><span class=\"float-right\"><a href=\"#\" class=\"link-black text-sm\"><i class=\"far fa-comments mr-1\"></i> Comments (5) </a></span></p><input class=\"form-control form-control-sm\" type=\"text\" placeholder=\"Type a comment\">", 3)
const _hoisted_37 = { class: "timeline timeline-inverse" }
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<div class=\"time-label\"><span class=\"bg-danger\"> 10 Feb. 2014 </span></div><div><i class=\"fas fa-envelope bg-primary\"></i><div class=\"timeline-item\"><span class=\"time\"><i class=\"far fa-clock\"></i> 12:05</span><h3 class=\"timeline-header\"><a href=\"#\">Support Team</a> sent you an email </h3><div class=\"timeline-body\"> Etsy doostang zoodles disqus groupon greplin oooj voxy zoodles, weebly ning heekya handango imeem plugg dopplr jibjab, movity jajah plickers sifteo edmodo ifttt zimbra. Babblely odeo kaboodle quora plaxo ideeli hulu weebly balihoo... </div><div class=\"timeline-footer\"><a href=\"#\" class=\"btn btn-primary btn-sm\">Read more</a><a href=\"#\" class=\"btn btn-danger btn-sm\">Delete</a></div></div></div><div><i class=\"fas fa-user bg-info\"></i><div class=\"timeline-item\"><span class=\"time\"><i class=\"far fa-clock\"></i> 5 mins ago</span><h3 class=\"timeline-header border-0\"><a href=\"#\">Sarah Young</a> accepted your friend request </h3></div></div><div><i class=\"fas fa-comments bg-warning\"></i><div class=\"timeline-item\"><span class=\"time\"><i class=\"far fa-clock\"></i> 27 mins ago</span><h3 class=\"timeline-header\"><a href=\"#\">Jay White</a> commented on your post </h3><div class=\"timeline-body\"> Take me to your leader! Switzerland is small and neutral! We are more like Germany, ambitious and misunderstood! </div><div class=\"timeline-footer\"><a href=\"#\" class=\"btn btn-warning btn-flat btn-sm\">View comment</a></div></div></div><div class=\"time-label\"><span class=\"bg-success\"> 3 Jan. 2014 </span></div>", 5)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-camera bg-purple" }, null, -1)
const _hoisted_44 = { class: "timeline-item" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "time" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock" }),
  /*#__PURE__*/_createTextVNode(" 2 days ago")
], -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("h3", { class: "timeline-header" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Mina Lee"),
  /*#__PURE__*/_createTextVNode(" uploaded new photos ")
], -1)
const _hoisted_47 = { class: "timeline-body" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock bg-gray" })
], -1)
const _hoisted_49 = /*#__PURE__*/_createStaticVNode("<form class=\"form-horizontal\"><div class=\"form-group row\"><label for=\"inputName\" class=\"col-sm-2 col-form-label\">Name</label><div class=\"col-sm-10\"><input type=\"email\" class=\"form-control\" id=\"inputName\" placeholder=\"Name\"></div></div><div class=\"form-group row\"><label for=\"inputEmail\" class=\"col-sm-2 col-form-label\">Email</label><div class=\"col-sm-10\"><input type=\"email\" class=\"form-control\" id=\"inputEmail\" placeholder=\"Email\"></div></div><div class=\"form-group row\"><label for=\"inputName2\" class=\"col-sm-2 col-form-label\">Name</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"inputName2\" placeholder=\"Name\"></div></div><div class=\"form-group row\"><label for=\"inputExperience\" class=\"col-sm-2 col-form-label\">Experience</label><div class=\"col-sm-10\"><textarea class=\"form-control\" id=\"inputExperience\" placeholder=\"Experience\"></textarea></div></div><div class=\"form-group row\"><label for=\"inputSkills\" class=\"col-sm-2 col-form-label\">Skills</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"inputSkills\" placeholder=\"Skills\"></div></div><div class=\"form-group row\"><div class=\"offset-sm-2 col-sm-10\"><div class=\"checkbox\"><label><input type=\"checkbox\"> I agree to the <a href=\"#\">terms and conditions</a></label></div></div></div><div class=\"form-group row\"><div class=\"offset-sm-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-danger\"> Submit </button></div></div></form>", 1)
const _hoisted_50 = [
  _hoisted_49
]

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_pf_image = _resolveComponent("pf-image")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t("labels.profile")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("labels.home")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t("labels.userProfile")), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_pf_image, {
                    class: "user-img",
                    src: require('@/assets/img/default-profile.png'),
                    alt: "User profile picture",
                    width: "100",
                    height: "100",
                    rounded: ""
                  }, null, 8, ["src"])
                ]),
                _hoisted_16
              ])
            ]),
            _hoisted_20
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("ul", _hoisted_24, [
                  _createElementVNode("li", _hoisted_25, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["nav-link", {'active' : _ctx.activeTab === 'ACTIVITY'}]),
                      onClick: _cache[0] || (_cache[0] = $event => (_ctx.setActiveTab('ACTIVITY')))
                    }, " Activity ", 2)
                  ]),
                  _createElementVNode("li", _hoisted_26, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["nav-link", {'active' : _ctx.activeTab === 'TIMELINE'}]),
                      onClick: _cache[1] || (_cache[1] = $event => (_ctx.setActiveTab('TIMELINE')))
                    }, " Timeline ", 2)
                  ]),
                  _createElementVNode("li", _hoisted_27, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["nav-link", {'active' : _ctx.activeTab === 'SETTINGS'}]),
                      onClick: _cache[2] || (_cache[2] = $event => (_ctx.setActiveTab('SETTINGS')))
                    }, " Settings ", 2)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["tab-pane", {'active' : _ctx.activeTab === 'ACTIVITY'}])
                  }, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_pf_image, {
                          src: require('@/assets/img/default-profile.png'),
                          alt: "user image",
                          width: "40",
                          height: "40",
                          rounded: ""
                        }, null, 8, ["src"]),
                        _hoisted_32
                      ]),
                      _hoisted_34
                    ])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["tab-pane", {'active' : _ctx.activeTab === 'TIMELINE'}])
                  }, [
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("div", null, [
                        _hoisted_43,
                        _createElementVNode("div", _hoisted_44, [
                          _hoisted_45,
                          _hoisted_46,
                          _createElementVNode("div", _hoisted_47, [
                            _createVNode(_component_pf_image, {
                              src: require('@/assets/img/default-profile.png'),
                              alt: "...",
                              width: "100",
                              height: "100"
                            }, null, 8, ["src"]),
                            _createVNode(_component_pf_image, {
                              src: require('@/assets/img/default-profile.png'),
                              alt: "...",
                              width: "100",
                              height: "100"
                            }, null, 8, ["src"]),
                            _createVNode(_component_pf_image, {
                              src: require('@/assets/img/default-profile.png'),
                              alt: "...",
                              width: "100",
                              height: "100"
                            }, null, 8, ["src"]),
                            _createVNode(_component_pf_image, {
                              src: require('@/assets/img/default-profile.png'),
                              alt: "...",
                              width: "100",
                              height: "100"
                            }, null, 8, ["src"])
                          ])
                        ])
                      ]),
                      _hoisted_48
                    ])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["tab-pane", {'active' : _ctx.activeTab === 'SETTINGS'}])
                  }, _hoisted_50, 2)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}